<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 操作按钮 -->
      <!--      <div class="ele-table-tool ele-table-tool-default">-->
      <!--        <el-button @click="add" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">添加-->
      <!--        </el-button>-->
      <!--        <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small">删除-->
      <!--        </el-button>-->
      <!--      </div>-->
      <!-- 数据表格 -->
      <ele-data-table ref="table" :config="table" :choose.sync="choose" highlight-current-row>
        <template #default="{ index }">
          <el-table-column type="selection" width="45" align="center" fixed="left" />
          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column prop="title" label="标题" show-overflow-tooltip min-width="110" />
          <el-table-column prop="createTime" label="发送时间" show-overflow-tooltip min-width="110" />
          <el-table-column label="操作" width="130px" align="center" :resizable="false">
            <template #default="{ row }">
              <el-link @click="details(row)" icon="el-icon-edit" type="primary" :underline="false">详情</el-link>
              <!--              <el-popconfirm title="确定要删除此用户吗？" @onConfirm="remove(row)" class="ele-action">-->
              <!--                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>-->
              <!--              </el-popconfirm>-->
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
      <!-- 详情弹窗 -->
      <el-dialog
        title="邮件详情"
        :visible.sync="showDetail"
        width="700px"
        :destroy-on-close="true"
        custom-class="ele-dialog-form"
        :lock-scroll="false"
      >
        <el-form label-width="82px" size="mini" class="ele-email-detail">
          <el-form-item label="标题:">
            <div style="font-size: 16px; font-weight: 700">
              {{ emailDetail.title }}
            </div>
          </el-form-item>
          <el-form-item label="接收人:">
            <el-tag v-for="item in emailDetail.teachers" :key="item.id" type="primary" size="mini">{{ item.teacherName }} </el-tag>
          </el-form-item>
          <el-form-item label="附件:">
            <div v-for="item in emailDetail.file" :key="item.id" style="font-weight: 700">
              {{ item.fileName }}
              <el-link :href="item.fileUrl" :underline="false" type="danger" target="_blank" style="margin-left: 20px">下载</el-link>
            </div>
          </el-form-item>
          <div style="margin: 15px 0 0 0">
            <el-divider />
          </div>
          <div v-html="emailDetail.detail" style="padding: 15px 20px"></div>
        </el-form>
        <div slot="footer">
          <el-button @click="showDetail = false">取消</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
  import { getEmailInfo } from '@/config/api';

  export default {
    name: 'TeacherList',
    data() {
      return {
        table: {
          // 表格配置
          url: '/email/getReciveEmailList',
          where: {},
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        choose: [], // 表格选中数据
        showDetail: false,
        emailDetail: {}, //邮件详情数据
      };
    },
    mounted() {},
    methods: {
      // 显示添加
      add() {
        this.showEdit = true;
      },
      /* 显示详情 */
      details(row) {
        let id = {
          id: row.id,
          type: 0,
        };
        //获取邮件详情
        getEmailInfo(id).then((res) => {
          if (res.data.resCode == 200) {
            this.emailDetail = res.data.data;
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
        // this.editForm = Object.assign({}, row);
        this.showDetail = true;
      },
      /* 删除 */
      // remove(row) {
      //   if (!row) {  // 批量删除
      //     if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
      //     // if(this.choose[0].roles[0].administrator == '1') return this.$message.error('不能删除初始管理员');
      //     let ids = this.choose.map(d => d.id);
      //     this.$confirm('确定要删除选中的用户吗?', '提示', {type: 'warning'}).then(() => {
      //       const loading = this.$loading({lock: true});
      //       let formData = new FormData();
      //       formData.append("ids", ids);
      //       formData.append("state", -1);
      //       batchDelSchoolTeacher(formData).then((res) => {
      //         loading.close();
      //         if (res.data.resCode == 200) {
      //           this.$message({type: 'success', message: res.data.resMsg});
      //           this.$refs.table.reload();
      //         } else {
      //           this.$message.error(res.data.resMsg);
      //         }
      //       }).catch(e =>{
      //         loading.close();
      //         this.$message.error(e.message);
      //       })
      //     }).catch(() => 0);
      //   } else {  // 单个删除
      //     // if(this.choose[0].roles[0].administrator == '1') return this.$message.error('不能删除初始管理员');
      //     const loading = this.$loading({lock: true});
      //     let formData = new FormData();
      //     formData.append("id", row.id);
      //     formData.append("state", -1);
      //     delSchoolTeacher(formData).then((res) => {
      //       loading.close();
      //       if (res.data.resCode == 200) {
      //         this.$message({type: 'success', message: res.data.resMsg});
      //         this.$refs.table.reload();
      //       } else {
      //         this.$message.error(res.data.resMsg);
      //       }
      //     }).catch(e =>{
      //       loading.close();
      //       this.$message.error(e.message);
      //     })
      //   }
      // },
    },
  };
</script>

<style scoped>
  .ele-block >>> .el-upload,
  .ele-block >>> .el-upload-dragger {
    width: 100%;
  }
  .org-tree-group {
    border: 1px solid hsla(0, 0%, 60%, 0.15);
    height: calc(100vh - 262px);
    box-sizing: border-box;
    overflow-x: auto;
  }

  .org-tree-group >>> .el-tree-node__content {
    height: 40px;
  }

  .org-tree-group >>> .el-tree-node__content > .el-tree-node__expand-icon {
    margin-left: 10px;
  }
</style>
